import { useFormContext } from "react-hook-form";
import { TaxDetails } from "../../../../../../../../components/taxDetails/TaxDetails";
import { TaxDetailsFormKeyProps } from "../../../../../../../../components/taxDetails/modelsAndSchemas/Models";
import { AddOrEditExpenseOrFeeFormKey } from "../../../../../../modelsAndSchemas/Models";
import { CURRENCY_FORMAT_MAP } from "../../../../../../../../components/textFieldCurrency/CurrencyUtils";
import { useForceUpdate } from "../../../../../../../../hooks/useForceUpdate";

interface AddFeesOrExpenseTaxDetails {
  isEditable?: boolean;
}

export const pageId = "addFeesAndExpenseTaxForm";

export const AddFeesAndExpenseTaxForm = ({
  isEditable = true,
}: AddFeesOrExpenseTaxDetails) => {
  const { getValues } = useFormContext();
  const forceUpdate = useForceUpdate();

  const {
    billingCurrency: billingCurrencyId,
    billingCurrencyName,
    billingAmount,
  } = getValues();
  const billingCurrencyFormat = CURRENCY_FORMAT_MAP[billingCurrencyName];

  const taxDetailsFormKeys: TaxDetailsFormKeyProps = {
    programFeeKey: AddOrEditExpenseOrFeeFormKey.feeOrExpenseAmount,
    taxKey: AddOrEditExpenseOrFeeFormKey.tax,
    taxPercentageKey: AddOrEditExpenseOrFeeFormKey.taxPercentage,
    taxAmountWithFormatKey: AddOrEditExpenseOrFeeFormKey.taxAmountWithFormat,
    taxAmountKey: AddOrEditExpenseOrFeeFormKey.taxAmount,
    taxEntriesKey: AddOrEditExpenseOrFeeFormKey.taxEntries,
    taxSearchKey: AddOrEditExpenseOrFeeFormKey.taxSearch,
  };

  return (
    <TaxDetails
      pageId={pageId}
      currencyFormat={billingCurrencyFormat}
      currencyName={billingCurrencyName}
      forceUpdate={forceUpdate}
      currencyId={billingCurrencyId}
      isInEditMode={isEditable}
      taxDetailsFormKeys={taxDetailsFormKeys}
      programOrProjectFee={billingAmount}
    />
  );
};
